// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const dwebble: PokeData = {
  "id": 557,
  "name": "dwebble",
  "height": 3,
  "weight": 145,
  "base_experience": 65,
  "types": [
    PokeType.BUG,
    PokeType.ROCK
  ],
  "api_moves": [
    "sand-attack",
    "withdraw",
    "rock-slide",
    "slash",
    "flail",
    "feint-attack",
    "fury-cutter",
    "rock-blast",
    "rock-polish",
    "x-scissor",
    "rock-wrecker",
    "stealth-rock",
    "bug-bite",
    "smack-down",
    "shell-smash"
  ],
  "moves": [
    "rock-slide",
    "rock-blast",
    "stealth-rock",
    "bug-bite",
    "lunge",
    "infest",
    "stone-crush",
    "pounce",
    "sticky-web",
    "ancient-power",
    "seismic-toss",
    "pin-rush",
    "string-shot"
  ],
  "evolution_chain": {
    "id": 284,
    "item": null,
    "species": [
      {
        "name": "dwebble",
        "order": 558,
        "types": [
          PokeType.BUG,
          PokeType.ROCK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "crustle",
        "order": 559,
        "types": [
          PokeType.BUG,
          PokeType.ROCK
        ],
        "evolves_from_species_id": 557,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 34,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 55,
    "speed": 55,
    "ability_power": 65
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
